import { render, staticRenderFns } from "./MenuLogos.vue?vue&type=template&id=236bde6c&scoped=true"
import script from "./MenuLogos.vue?vue&type=script&lang=js"
export * from "./MenuLogos.vue?vue&type=script&lang=js"
import style0 from "./MenuLogos.vue?vue&type=style&index=0&id=236bde6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bde6c",
  null
  
)

export default component.exports